<app-split-container>
  <div slot="left">
    <opac-button
      *ngIf="lastScreen() === 'login'"
      class="back-button"
      [ariaLabel]="'general.back' | translate"
      [opacTooltip]="'general.back' | translate"
      (click)="loadLogin($event)">
      <opac-icon icon="navigate_back" slot="only-icon"></opac-icon>
    </opac-button>

    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.screens.signup.infoTitle' | translate"
      [subtitle]="'login.screens.signup.infoSubtitle' | translate"
    >
      <app-signup-image></app-signup-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <p>* {{ 'login.screens.signup.requiredFieldsDescription' | translate }}</p>

    <form id="signup-form" [formGroup]="form" (submit)="signup($event)">
      <formly-form
        [model]="formModel"
        [fields]="selectedFormFields"
        [options]="formOptions"
        [form]="form"
      ></formly-form>
    </form>

    <ng-container *ngIf="!showValidateRutButton()">
      <div class="checkboxes-container">
        <opac-checkbox
          *ngFor="let checkbox of checkboxes()"
          [checked]="checkbox.state"
          (change)="handleCheckboxCheck(checkbox, $event)"
        >
          <span [innerHTML]="checkbox.text"></span>
        </opac-checkbox>
      </div>

      <opac-button
        class="submit-button"
        actionType="submit"
        form="signup-form"
        [disabled]="form.invalid || isAnyCheckboxUnchecked()"
      >
        {{ 'general.submit' | translate }}
      </opac-button>
    </ng-container>

    <opac-button
      *ngIf="showValidateRutButton()"
      class="submit-button"
      [disabled]="form.invalid"
      (click)="validateRutCode()"
    >
      {{ 'signup.custom.validate' | translate }}
    </opac-button>

    <opac-divider>{{ 'general.or' | translate }}</opac-divider>

    <div class="links-container">
      <span>
        {{ 'login.screens.signup.goToLoginText' | translate }}
        <a
          href="#"
          (click)="loadLogin($event)"
          (keydown.enter)="loadLogin($event)"
          (keydown.space)="loadLogin($event)"
        >
          {{ 'login.screens.signup.goToLoginLink' | translate }}
        </a>
      </span>
    </div>
  </div>
</app-split-container>
